import ComparisonChart from './comparisonChart.component';

export default ComparisonChart;